// extracted by mini-css-extract-plugin
export var active = "index-module--active--6V307";
export var container = "index-module--container--XsV0Q";
export var greenBox = "index-module--greenBox--c0WNM";
export var icon = "index-module--icon--5YfT6";
export var wordSlide = "index-module--wordSlide--qF3lt";
export var wordSlider = "index-module--wordSlider--Ujqu9";